import Input from '@hotmart/space-lib/dist/components/form/textField'
import styled from 'styled-components'

export const InputCounter = styled.div`
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  color: var(--gray-500);
  background-color: var(--dropdown-background-color);

  span {
    color: inherit;
    font-size: inherit;
  }
`

export const TextField = styled(Input)`
  &::placeholder {
    color: var(--gray-700) !important;
  }
`
